import { login } from '@betty/auth/state';
import { submitRegistrationForm } from '@betty/registration/state';
import { apiConfig } from '@betty/toolkit/api';
import {
  appAuthenticated,
  appOpened,
  startListening,
} from '@betty/toolkit/state';
import { jwtDecode } from 'jwt-decode';
import { mapRegistrationCompletedEventData } from './gtm.utils';

/* eslint-disable */
// @ts-ignore-start
export const initGtmV2 = () => !function(){"use strict";function e(e){return function(e){for(var t=0,r=document.cookie.split(";");t<r.length;t++){var n=r[t].split("=");if(n[0].trim()===e)return n[1]}}(e)}function t(e){return localStorage.getItem(e)}function r(e){return window[e]}function n(e,t){var r=document.querySelector(e);return t?null==r?void 0:r.getAttribute(t):null==r?void 0:r.textContent}!function(o,i,a,c,u,l,s,v,d,f,g){var E,I,m,T;try{I=d&&(m=navigator.userAgent,(T=new RegExp("Version/([0-9._]+)(.*Mobile)?.*Safari.*").exec(m))&&parseFloat(T[1])>=16.4)?function(o,i,a){void 0===i&&(i="");var c={cookie:e,localStorage:t,jsVariable:r,cssSelector:n},u=Array.isArray(i)?i:[i];if(o&&c[o])for(var l=c[o],s=0,v=u;s<v.length;s++){var d=v[s],f=a?l(d,a):l(d);if(f)return f}else console.warn("invalid uid source",o)}(d,"user_id",""):void 0}catch(e){console.error(e)}var _=o;_[c]=_[c]||[],_[c].push({"gtm.start":(new Date).getTime(),event:"gtm.js"});var p=i.getElementsByTagName(a)[0],A=I?"&bi="+encodeURIComponent(I):"",N=i.createElement(a),D=I?"kp"+v:v,R=!I&&s?s:"https://ss.betty.ca";N.async=!0,N.src=R+"/"+D+`.js?id=GTM-M4CCLL2&l=gtmDataLayer`+A,null===(E=p.parentNode)||void 0===E||E.insertBefore(N,p)}(window,document,"script","gtmDataLayer",0,0,"https://load.ss.betty.ca","nndhssdz","jsVariable")}();
// @ts-ignore-end
/* eslint-enable */

if (!__DEV__) {
  startListening({
    actionCreator: appOpened,
    effect: () => {
      initGtmV2();
    },
  });

  startListening({
    actionCreator: login.fulfilled,
    effect: (action) => {
      const profile = jwtDecode(action.payload.id_token);

      if (profile.sub) {
        window.gtmDataLayer?.push({
          event: 'login',
          method: 'Manual login', // user is automatically logged in after registration process
          user_id: profile.sub, // push internal userID/customer ID
        });
      }
    },
  });

  startListening({
    actionCreator: appAuthenticated,
    effect: async () => {
      const userId = await apiConfig.getUserId();

      window.gtmDataLayer?.push({
        login_status: userId ? 'Logged in' : 'Not logged in',
        user_id: userId,
      });
    },
  });

  startListening({
    actionCreator: submitRegistrationForm.fulfilled,
    effect: (action) => {
      const params = mapRegistrationCompletedEventData(action.payload);

      window.gtmDataLayer?.push({
        event: 'registration_process_completed',
        ...params,
      });
    },
  });
}

declare global {
  interface Window {
    gtmDataLayer?: {
      push: (event: unknown) => void;
    };
  }
}
